import { actions } from '@ecosystem/newron-design-system';
import React from 'react';

import { useInfoModal } from '@components/info-modal/Hooks';

const PageInfo: React.FC<{ title: string; content: React.ReactElement | string }> = ({ title, content }) => {
  const showInfoModal = useInfoModal();
  return (
    <div className="inline-block ml-4">
      <actions.IconButton onClick={() => showInfoModal(title, content)} testId="button-icon">
        <actions.IconButton.icons.HelpOutline />
      </actions.IconButton>
    </div>
  );
};

export default PageInfo;
